export const mcpConnectionsEnUS = {
  title: "AI Connections",
  description:
    "Apps you've approved to use your Invup account in {{organization}}. Each one acts as you, with your role.",
  approved: "Approved: {{date}}",
  lastUsedPrefix: "Last used",
  neverUsed: "Never used",
  status: {
    active_one: "Active · 1 day left",
    active_other: "Active · {{count}} days left",
    expiringSoon_one: "Expires in 1 day",
    expiringSoon_other: "Expires in {{count}} days",
    expiresToday: "Expires today",
    disabledByOrganization: "Disabled by organization",
    expired: "Expired",
  },
  expiryNote:
    "Connections last 180 days from approval. After that, the app asks you to approve it again. A connection also stops working after 30 days without use.",
  disconnect: "Disconnect",
  disconnectAriaLabel: "Disconnect {{client}}, approved {{date}}",
  confirmTitle: "Disconnect App",
  confirmBody:
    "Are you sure you want to disconnect {{client}}, approved {{date}}? It stops working right away. The next time you use it, it will ask you to connect again.",
  confirmBodyExpired: "Remove {{client}}, approved {{date}}, from this list?",
  confirmButton: "Disconnect",
  disconnectError:
    "Sorry, this connection could not be disconnected due to an error on our end. Please try again.",
  disconnectedToast:
    "{{client}} disconnected successfully. It will ask you to connect again the next time you use it.",
  alreadyDisconnectedToast: "{{client}} was already disconnected.",
  loading: "Loading your AI connections…",
  loadError:
    "Sorry, your AI connections could not be loaded due to an error on our end. Please try again.",
  retry: "Try Again",
  emptyTitle: "No AI connections yet",
  emptyBody:
    "Connect an AI app, such as Claude, ChatGPT or Cursor, to work with your time entries, projects and clients by chatting with it. A connection can only see or change what your role allows.",
  help: {
    title: "Connect an AI App",
    hint: "Use these to connect another app. Each app asks you to approve it in your browser.",
    hintEmpty:
      "Use these to connect an app. Each app asks you to approve it in your browser.",
    serverUrlLabel: "Server URL",
    commandLabel: "In Claude Code",
    commandHint: "Run this in your terminal.",
    anyClient:
      "Any app that supports MCP (Model Context Protocol) can connect with the server URL.",
    requirement: "Your organization must have AI connections turned on.",
    copy: "Copy",
    copied: "Copied",
    serverUrlTarget: "server URL",
    commandTarget: "command",
    serverUrlCopied: "Server URL copied",
    commandCopied: "Command copied",
    copyFailed: "Couldn't copy. Select the text and copy it instead.",
  },
  optedOut: {
    title: "AI connections are turned off in {{organization}}",
    body: "Your connections are paused, not deleted. Someone who manages integrations can turn them back on. Any connection unused for more than 30 days will need to be connected again.",
    bodyNone:
      "You can connect an app once someone who manages integrations turns connections back on.",
    bodyManager:
      "Your connections are paused, not deleted. You can turn them back on in AI Connections settings. Any connection unused for more than 30 days will need to be connected again.",
    bodyManagerNone:
      "You can connect an app once connections are turned back on. You can do that in AI Connections settings.",
    manageLink: "Go to AI Connections settings",
  },
  featureRequired: {
    title: "AI connections need the Pro plan",
    body: "{{organization}} isn't on the Pro plan, so your connections are paused, not deleted. Ask your organization owner about upgrading. Any connection unused for more than 30 days will need to be connected again.",
    bodyNone:
      "{{organization}} isn't on the Pro plan, so AI apps can't be connected yet. Ask your organization owner about upgrading.",
    bodyBilling:
      "{{organization}} isn't on the Pro plan, so your connections are paused, not deleted. Any connection unused for more than 30 days will need to be connected again.",
    bodyBillingNone:
      "{{organization}} isn't on the Pro plan, so AI apps can't be connected yet.",
    upgrade: "Upgrade to Pro",
  },
  unavailable: {
    title: "AI connections are temporarily unavailable",
    body: "Invup has paused AI connections for every organization. Your connections are kept and will work again once the service is back. Any connection unused for more than 30 days will need to be connected again.",
    bodyNone:
      "Invup has paused AI connections for every organization. Try connecting again later.",
  },
};
